import client from "../../../apolloClient";
import { GET_NOTIFICATION_LEDGER_GLOBAL } from "../../../graphql/Notifications/query";

export const FetchingAnnouncementNotification = (page: number = 1, limit: number = 10) => async () => {
  try {
    console.log("fetching announcement")
    const { data } = await client.query({
      query: GET_NOTIFICATION_LEDGER_GLOBAL,
      variables: {
        page,
        limit
      },
      fetchPolicy: "network-only"
    });
    if (data?.getNotificationLedgerGlobal) {
      return {
        success: true,
        data: data.getNotificationLedgerGlobal
      };
    }
    return {
      success: false,
      data: null
    };
  } catch (error) {
    console.error("Error fetching notifications:", error);
    return {
      success: false,
      data: null,
      error
    };
  }
};
